import React, { useState, useEffect } from 'react';
import { getTimeUntilMidnight, formatTime } from '../utils/landingHelpers';
import { Clock } from 'react-bootstrap-icons';
import { useTranslation } from '../../i18n';

interface OfferCountdownProps {
    offerText?: string;
}

const OfferCountdown: React.FC<OfferCountdownProps> = ({ 
    offerText
}) => {
    const { t } = useTranslation();
    const displayText = offerText || t('landing.special_offer_ends_in');
    const [timeLeft, setTimeLeft] = useState(getTimeUntilMidnight());

    useEffect(() => {
        const interval = setInterval(() => {
            setTimeLeft(getTimeUntilMidnight());
        }, 1000);

        return () => clearInterval(interval);
    }, []);

    const isUrgent = timeLeft.hours < 1;

    return (
        <div className={`offer-countdown ${isUrgent ? 'urgent' : ''}`}>
            <div className="d-flex align-items-center justify-content-center">
                <Clock 
                    className={`me-2 ${isUrgent ? 'text-danger' : ''}`}
                    size={20}
                />
                <span className="offer-text me-2">{displayText}</span>
                <strong className={`countdown-timer ${isUrgent ? 'text-danger' : 'text-primary'}`}>
                    {formatTime(timeLeft)}
                </strong>
            </div>
        </div>
    );
};

export default OfferCountdown;